
const ErrorPage = () => {
    return (
        <div className="max-w-2xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:max-w-7xl lg:px-8">
            <h2 className="text-2xl font-extrabold tracking-tight text-gray-900">Error with Server</h2>
            <h5 className="text-1xl tracking-tight text-gray-600">Please come back later</h5>
        </div>
    )
}

export default ErrorPage;